export default "__VITE_ASSET__D0F9U$Ft__"